import React from 'react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import PageTransition from '@/components/transitions/PageTransition';

export default function SiteShell() {
  return (
    <div className="min-h-screen flex flex-col bg-[#050B17] text-white">
      <Header />
      <main className="flex-1">
        {/* PageTransition wraps the active route via useOutlet() inside
            framer-motion AnimatePresence for a smooth fade + slight slide.
            Respects prefers-reduced-motion. */}
        <PageTransition />
      </main>
      <Footer />
    </div>
  );
}
